import { Device } from '../types/models'
import Model3 from '../svg/model3-explained.svg'
import { Box, SxProps, Theme } from '@mui/material'

export interface DeviceDiagramProps {
  device: Device
  sx?: SxProps<Theme>
}

export function DeviceDiagram(props: DeviceDiagramProps): React.ReactElement {

  return (
    <Box sx={props.sx}>
      <img alt="Model3 diagram" width="100%" src={Model3}></img>
    </Box>
  )
}
